import { render, staticRenderFns } from "./workDialog.vue?vue&type=template&id=b71498a4&scoped=true&"
import script from "./workDialog.vue?vue&type=script&lang=js&"
export * from "./workDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71498a4",
  null
  
)

export default component.exports